











































import { defineComponent, inject, reactive, toRefs } from '@vue/composition-api'

// Store
import { StoreKey as FormStoreKey } from '@/store/Form'

const getComponentState = () => {
    const state = reactive({
        isOpenModal: false,
    })

    return toRefs(state)
}

export default defineComponent({
    setup() {
        const formStore = inject(FormStoreKey)
        if (!formStore) {
            throw new Error(`${FormStoreKey} is not provided`)
        }

        const state = getComponentState()

        const openModalHandler = () => {
            state.isOpenModal.value = true
        }
        const closeModalHandler = () => {
            state.isOpenModal.value = false
        }

        return {
            formStore,
            ...state,
            openModalHandler,
            closeModalHandler,
        }
    },
})
